import {
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';

// import monitorReducersEnhancer from './enhancers/monitorReducers'
import loggerMiddleware from './middleware/logger';
import authMiddleware from './middleware/auth';
import apiErrorMiddleware from './middleware/apiError';
import wsMiddleware from './middleware/socketMiddleware';
import rootReducer from './reducers';
import thunkMiddleware from 'redux-thunk';

export default function configureAppStore(preloadedState = {}) {
  const store = configureStore({
    reducer: rootReducer,
    middleware: [
      wsMiddleware,
      thunkMiddleware, // lets us dispatch() functions .. see https://redux.js.org/advanced/async-actions
      loggerMiddleware,
      authMiddleware,
      apiErrorMiddleware,
      ...getDefaultMiddleware(),
    ],
    preloadedState,
    enhancers: [
      // monitorReducersEnhancer
    ],
  });

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () =>
      store.replaceReducer(rootReducer),
    );
  }

  return store;
}
